module.exports = __webpack_public_path__ + "static/media/ic_family_dashboard_gold.cb2a13ee.svg";